import { Fragment, useEffect, useRef, useState } from "react";
import { Button, Dialog, Link } from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import "./ProjectAndOffsetStatusUpdate.scss";
import TextArea from "antd/es/input/TextArea";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { updateStatusOffsetService } from "../../services/offsetService";
import { DatePicker, DatePickerProps, Input } from "antd";
import { Moment } from "moment";
import FileAttachmentsDetails from "../common/FileAttachmentsDetails";
const ProjectsAndOffsetsStatusUpdate = (props: any) => {
  const {
    setOpenUpdate,
    openUpdate,
    updateStatusFormData,
    setUpdateStatusFormData,
    eachOffsetData,
    statusUpdateSelectedIndex,
    toStatus,
    setToStatus,
    setOffsetsList,
    offsetsList,
    statusUpdateSelectedListIndex,
    setEachOffsetData,
    fromDetailedView,
  } = props;

  const { RangePicker } = DatePicker;
  const [enableUpdate, setEnableUpdate] = useState(false);

  const isMandatoryFilled = () => {
    let isValid: any = enableUpdate;

    if (toStatus === "Retire-Partially") {
      if (updateStatusFormData?.toValue === 0) {
        isValid =
          updateStatusFormData?.retiredFrom &&
          Object.keys(updateStatusFormData?.retiredFrom)?.length === 0 &&
          updateStatusFormData?.retiredTo &&
          Object.keys(updateStatusFormData?.retiredTo)?.length === 0;
      } else {
        isValid =
          !errorMessage?.length &&
          updateStatusFormData?.toValue &&
          updateStatusFormData?.retiredFrom &&
          Object.keys(updateStatusFormData?.retiredFrom)?.length === 0 &&
          updateStatusFormData?.retiredTo &&
          Object.keys(updateStatusFormData?.retiredTo)?.length === 0;
      }
    } else if (toStatus === "Retire-Fully") {
      isValid =
        updateStatusFormData?.retiredFrom &&
        Object.keys(updateStatusFormData?.retiredFrom)?.length === 0 &&
        updateStatusFormData?.retiredTo &&
        Object.keys(updateStatusFormData?.retiredTo)?.length === 0;
    } else if (toStatus === "Transfer") {
      isValid =
        updateStatusFormData?.transferredDate &&
        Object.keys(updateStatusFormData?.transferredDate)?.length === 0;
    }
    isValid =
      isValid &&
      updateStatusFormData?.certificateNumber &&
      updateStatusFormData?.retirementDate;
    setEnableUpdate(!!isValid);
    return isValid;
  };

  const handleStatusUpdate = () => {
    // setOpenUpdate(false);
    let selectedToStatus: any;
    if (toStatus === "Retire-Partially") {
      if (updateStatusFormData?.toValue === 0) {
        selectedToStatus = "Retired-Fully";
        setToStatus(selectedToStatus);
      } else {
        selectedToStatus = "Retired-Partially";
        setToStatus(selectedToStatus);
      }
    } else if (toStatus === "Retire-Fully") {
      selectedToStatus = "Retired-Fully";
      setToStatus(selectedToStatus);
    } else if (toStatus === "Transfer") {
      selectedToStatus = "Transferred";
      setToStatus(selectedToStatus);
    } else {
      selectedToStatus = toStatus;
      setToStatus(selectedToStatus);
    }
    let retirePartialFromValue;
    let retirePartialToValue: any;
    if (toStatus !== "Retire-Partially") {
      retirePartialFromValue = eachOffsetData.active_value;
      retirePartialToValue = 0;
    } else {
      retirePartialFromValue = updateStatusFormData?.fromValue;
      retirePartialToValue = updateStatusFormData?.toValue;
    }
    // updateStatusFormData.attachments = {
    //   files: updateStatusFormData.attachments,
    // };
    updateStatusOffsetService({
      ...updateStatusFormData,
      attachments: {
        files: updateStatusFormData.attachments,
      },
      fromCreditStatus: eachOffsetData?.credit_status,
      creditStatus: selectedToStatus,
      id: statusUpdateSelectedIndex,
      toValue: retirePartialToValue,
      fromValue: retirePartialFromValue,
    })
      .then((res: any) => {
        setUpdateStatusFormData({
          retiredFrom: null,
          retiredTo: null,
          transferredDate: null,
          comments: "",
          attachments: [],
          toValue: null,
          fromValue: null,
          certificateNumber: "",
          retirementDate: null,
        });
        if (fromDetailedView) {
          const eachEmissions = eachOffsetData;
          eachEmissions.credit_status = selectedToStatus;
          setEachOffsetData(eachEmissions);
        }
        const prevOffsetList = offsetsList;
        prevOffsetList[statusUpdateSelectedListIndex].credit_status =
          selectedToStatus;
        prevOffsetList[statusUpdateSelectedListIndex].active_value =
          retirePartialToValue;
        setOffsetsList(prevOffsetList);

        setOpenUpdate(false);
      })
      .catch((e: any) => {
        console.log(e);
      });
  };

  const handleClose = () => {
    setUpdateStatusFormData({
      ...updateStatusFormData,
      retiredFrom: null,
      retiredTo: null,
      transferredDate: null,
      comments: "",
      attachments: [],
      toValue: null,
      fromValue: null,
    });
    // setEachOffsetData({});
    setOpenUpdate(false);
  };

  const onDateChange: DatePickerProps["onChange"] = (
    date: any,
    dateString: any
  ) => {
    let fullDate = new Date(date.$d);
    setUpdateStatusFormData({
      ...updateStatusFormData,
      ["transferredDate"]: fullDate,
    });
  };
  const monthFormat = "YYYY/MM";
  const [defaultDateRange, setDefaultRange] = useState<any>([]);

  const [startMonth, setStartMonth] = useState(
    new Date(new Date().getFullYear(), 0, 2)
  );
  const [endMonth, setEndMonth] = useState(
    new Date(new Date().getFullYear(), 11, 31)
  );
  type RangeValue = [Moment | null, Moment | null] | null;
  const [dates, setDates] = useState<RangeValue>(null);

  const onChangeDate = (e: any) => {
    let startDate = new Date(e[0].$d);
    startDate = new Date(startDate.getFullYear(), startDate.getMonth(), 2);
    setStartMonth(startDate);
    let endDate = new Date(e[1].$d);
    endDate = new Date(endDate.getFullYear(), endDate.getMonth() + 1, 1);
    setEndMonth(endDate);
    setUpdateStatusFormData({
      ...updateStatusFormData,
      retiredFrom: startDate,
      retiredTo: endDate,
    });
  };

  const onOpenChange = (open: boolean) => {
    if (open) {
      setDates([null, null]);
    } else {
      setDates(null);
    }
  };

  const [errorMessage, setErrorMessage] = useState("");

  const handleAmountChange = (e: any) => {
    const enteredValue = parseFloat(e.target.value);
    const { active_value } = eachOffsetData;

    if (enteredValue > active_value) {
      setErrorMessage(
        "Carbon Offset Amount should be less than the available value."
      );
    } else {
      setErrorMessage("");
      setUpdateStatusFormData({
        ...updateStatusFormData,
        toValue: active_value - enteredValue,
        fromValue: active_value,
      });
    }
  };

  const handleFieldChange = (field: any, value: any) => {
    const updateObj: any = {};
    updateObj[field] = value;
    setUpdateStatusFormData({
      ...updateStatusFormData,
      ...updateObj,
    });
  };

  useEffect(() => {
    isMandatoryFilled();
  }, [updateStatusFormData, handleAmountChange]);

  return (
    <Fragment>
      <div className="pw-file-attachement-container">
        <Dialog className="pw-dialog-container-test" open={openUpdate}>
          <div className="pw-dialog-container">
            <div className="flex justify-between items-center w-full">
              <div className="pw-header-text">Update status</div>
              <div className="cursor-pointer">
                <CloseIcon
                  className="pw-color-close-attchments"
                  onClick={handleClose}
                />
              </div>
            </div>

            <div className="flex justify-between items-center w-full mt-1">
              <div className="pw-color-neutral-900 text-sm">
                Are you sure you want to update the credit status from
                <span
                  className={`font-bold pw-${eachOffsetData?.credit_status.toLowerCase()}`}
                >
                  {" "}
                  {eachOffsetData?.credit_status}
                </span>{" "}
                to{" "}
                <span className={`font-bold pw-${toStatus.toLowerCase()}`}>
                  {" "}
                  {toStatus}
                </span>{" "}
              </div>
            </div>

            {toStatus !== "Retire-Partially" ? (
              <div className="mt-4">
                <div className="pw-color-neutral-600 text-sm">
                  Carbon offset amount
                  <span className="pw-mandatory-icon"> *</span>
                </div>
                <Input
                  disabled={true}
                  type="number"
                  value={eachOffsetData.active_value}
                  placeholder="Amount"
                  className="h-[2.5rem] w-52  mt-1"
                />
              </div>
            ) : (
              <div>
                <div className="mt-4 ">
                  <div className="pw-color-neutral-600 text-sm">
                    Carbon offset amount
                    <span className="pw-mandatory-icon"> *</span>
                  </div>
                  <Input
                    onChange={handleAmountChange}
                    type="number"
                    placeholder="Enter Amount"
                    className="h-[2.5rem] w-52  mt-1"
                  />
                  {errorMessage && (
                    <div className="text-red-500 text-sm mt-2">
                      {errorMessage}
                    </div>
                  )}
                </div>
                <div className="pw-color-neutral-600 text-sm py-2 mt-2">
                  Available offset amount :{" "}
                  <span>{eachOffsetData.active_value}</span>
                </div>
              </div>
            )}

            <div className="flex flex-row gap-16 items-center">
              <div className="mt-4">
                <div className="pw-color-neutral-600 text-sm">
                  Certificate number
                  <span className="pw-mandatory-icon"> *</span>
                </div>
                <Input
                  placeholder="Enter certificate number"
                  type="text"
                  className="h-[2.5rem] w-52  mt-1"
                  onChange={(e) => {
                    handleFieldChange("certificateNumber", e?.target?.value);
                  }}
                />
              </div>

              <div className="mt-4">
                <div className="pw-color-neutral-600 text-sm">
                  Retirement date
                  <span className="pw-mandatory-icon"> *</span>
                </div>
                <DatePicker
                  className="pw-date-picker"
                  placeholder="Select retirement date"
                  onChange={(e) => {
                    handleFieldChange("retirementDate", e);
                  }}
                  getPopupContainer={(triggerNode: any) => {
                    return triggerNode.parentNode;
                  }}
                />
              </div>
            </div>

            {toStatus === "Transfer" && (
              <div className="mt-4">
                <div className="pw-color-neutral-600 text-sm">
                  Transfered date
                  <span className="pw-mandatory-icon"> *</span>
                </div>
                <DatePicker
                  className="pw-date-picker"
                  placeholder="Select Status Date"
                  onChange={onDateChange}
                  getPopupContainer={(triggerNode: any) => {
                    return triggerNode.parentNode;
                  }}
                />
              </div>
            )}

            {(toStatus === "Retire-Fully" ||
              toStatus === "Retire-Partially") && (
              <div className="mt-4">
                <div className="pw-color-neutral-600 text-sm">
                  Offset period
                  <span className="pw-mandatory-icon"> *</span>
                </div>
                <RangePicker
                  className="pw-selectbunit"
                  picker="month"
                  onCalendarChange={(val: any) => {
                    setDates(val);
                  }}
                  onChange={onChangeDate}
                  onOpenChange={onOpenChange}
                  placeholder={["From", "To"]}
                  defaultValue={defaultDateRange}
                  format={monthFormat}
                  getPopupContainer={(triggerNode: any) => {
                    return triggerNode.parentNode;
                  }}
                />
              </div>
            )}

            <div className="w-full mt-4">
              <div className="pw-color-neutral-600 text-sm">Add comments</div>
              <TextArea
                value={updateStatusFormData?.comments}
                onChange={(e) =>
                  setUpdateStatusFormData({
                    ...updateStatusFormData,
                    comments: e.target.value,
                  })
                }
                placeholder="Comments"
                className="w-full pw-comments-field mt-1 p-4"
              />
              <div className="flex justify-end pw-color-neutral-400">0/100</div>
            </div>

            <FileAttachmentsDetails
              formData={updateStatusFormData}
              setFormData={setUpdateStatusFormData}
            ></FileAttachmentsDetails>
          </div>
          <div className="flex flex-row justify-end pw-bunit-footer w-full gap-6 py-4">
            <div
              className="pw-bunit-button-light pw-bunit-button-next text-neutral bg-white font-bold"
              onClick={handleClose}
            >
              Cancel
            </div>
            <button
              className={`pw-bunit-button-primary pw-bunit-button-next text-white font-bold ${
                enableUpdate
                  ? "cursor-pointer bg-primary"
                  : "text-black bg-neutral-300"
              }`}
              onClick={enableUpdate ? handleStatusUpdate : undefined}
              disabled={!enableUpdate}
            >
              Save
            </button>
          </div>
        </Dialog>
      </div>
    </Fragment>
  );
};

export default ProjectsAndOffsetsStatusUpdate;
